function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.99 0C5.46999 0 0.98999 4.48 0.98999 10C0.98999 15.52 5.46999 20 10.99 20C16.51 20 20.99 15.52 20.99 10C20.99 4.48 16.51 0 10.99 0ZM14.6 6.34C15.67 6.34 16.53 7.2 16.53 8.27C16.53 9.34 15.67 10.2 14.6 10.2C13.53 10.2 12.67 9.34 12.67 8.27C12.66 7.2 13.53 6.34 14.6 6.34ZM8.59999 4.76C9.89999 4.76 10.96 5.82 10.96 7.12C10.96 8.42 9.89999 9.48 8.59999 9.48C7.29999 9.48 6.23999 8.42 6.23999 7.12C6.23999 5.81 7.28999 4.76 8.59999 4.76ZM8.59999 13.89V17.64C6.19999 16.89 4.29999 15.04 3.45999 12.68C4.50999 11.56 7.12999 10.99 8.59999 10.99C9.12999 10.99 9.79999 11.07 10.5 11.21C8.85999 12.08 8.59999 13.23 8.59999 13.89ZM10.99 18C10.72 18 10.46 17.99 10.2 17.96V13.89C10.2 12.47 13.14 11.76 14.6 11.76C15.67 11.76 17.52 12.15 18.44 12.91C17.27 15.88 14.38 18 10.99 18Z"
});

function SvgUsersTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "#A8B8CA",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersTeam);
export default __webpack_public_path__ + "static/media/users-team.27243e73.svg";
export { ForwardRef as ReactComponent };